{
  "version": 1,
  "asset_id": "01cac01b-22ba-4a33-a7ca-3965a790bca9",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/01cac01b-22ba-4a33-a7ca-3965a790bca9/bypass-revision-oversized-pouch-es-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/01cac01b-22ba-4a33-a7ca-3965a790bca9/bypass-revision-oversized-pouch-es-320.webp",
  "original_filename": "bypass-revision-oversized-pouch-es-320.webp",
  "size": 13964,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:16Z"
}
